/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iconik_Publish_Icon_AltInputs */



/**
* | output |
* | --- |
* | "iconik icon" |
*
* @param {Iconik_Publish_Icon_AltInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iconik_publish_icon_alt = /** @type {((inputs?: Iconik_Publish_Icon_AltInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iconik_Publish_Icon_AltInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("icone iconik")
	if (locale === "de") return /** @type {LocalizedString} */ ("Iconik-Symbol")
	if (locale === "it") return /** @type {LocalizedString} */ ("icona iconica")
	if (locale === "ru") return /** @type {LocalizedString} */ ("иконическая икона")
	if (locale === "es") return /** @type {LocalizedString} */ ("icono de iconik")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("iconik 图标")
	if (locale === "ja") return /** @type {LocalizedString} */ ("iconikアイコン")
	if (locale === "hi") return /** @type {LocalizedString} */ ("आइकॉनिक आइकन")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("ícone icônico")
	return /** @type {LocalizedString} */ ("iconik icon")
});